import React from "react";

const Live = () => {
  // Replace with your YouTube live stream video ID
  const liveVideoId = "5wdsouctcHQ"; 

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100" style={{padding:'0px'}}>
      <div className="w-full max-w-4xl aspect-video">
        <iframe style={{width:'100%',height:'100vh'}}
          className="w-full h-full rounded-xl shadow-lg"
          src={`https://www.youtube.com/embed/${liveVideoId}?autoplay=1&mute=1&playsinline=1&controls=0&modestbranding=1`}
          title="YouTube Live Stream"
          frameBorder="0"
          allow="autoplay; encrypted-media; fullscreen"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Live;
